import { render, staticRenderFns } from "./TableOperate.vue?vue&type=template&id=992c6598&scoped=true&"
import script from "./TableOperate.vue?vue&type=script&lang=js&"
export * from "./TableOperate.vue?vue&type=script&lang=js&"
import style0 from "./TableOperate.vue?vue&type=style&index=0&id=992c6598&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992c6598",
  null
  
)

export default component.exports